import { FC } from 'react'
import { Center } from '@chakra-ui/react'

interface TimerProps {
  timeLeft: number
}

export const Timer: FC<TimerProps> = ({ timeLeft }) => {
  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft - minutes * 60

  const pad = (t: number) => `${t}`.padStart(2, '0')

  return (
    <Center
      fontSize="48px"
      h="64px"
      bg="#3C4043"
      borderRadius="32px"
      mx={8}
      color="#FFC130"
      boxShadow="1px 7px 6px rgba(73, 76, 79, 0.3)"
      letterSpacing="5%"
    >
      {pad(minutes)}:{pad(seconds)}
    </Center>
  )
}
